<template>
  <div class="set-location-map">
    <div
      class="modal set-location-map-modal"
      style="position: absolute !important"
    >
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <div class="field" style="margin-bottom: 0">
            <div class="control">
              <div class="select is-fullwidth">
                <select @change="selectCountry($event)">
                  <option disabled selected value>-- Select Country --</option>
                  <option value="th">🇹🇭 Thailand</option>
                  <option value="sg">🇸🇬 Singapore</option>
                  <option value="mm">🇲🇲 Myanmar</option>
                  <option value="kh">🇰🇭 Cambodia</option>
                  <option value="my">🇲🇾 Malaysia</option>
                  <option value="vn">🇻🇳 Vietnam</option>
                  <option value="id">🇮🇩 Indonesia</option>
                  <option value="ph">🇵🇭 Philippines</option>
                  <option value="jp">🇯🇵 Japan</option>
                  <option value="pt">🇵🇹 Portugal</option>
                </select>
              </div>
            </div>
          </div>
          <div class="notification has-text-left" @click="editAddress">
            <i
              class="fa fa-map-marker-alt has-text-grey"
              style="margin-right: 4px"
            />

            <span>{{ $store.state.selectedBusiness.address }}</span>
            <i class="fa fa-pencil-alt is-pulled-right has-text-success" />
          </div>
          <div class="map-wrapper">
            <div id="business-location-map" />
          </div>
          <div
            class="notification is-warning has-text-link"
            style="z-index: 999; margin-top: -44px; margin-bottom: 0px"
          >
            Click yellow/blue dot to save location
          </div>
          <div class="lat-lon">
            <span class="button is-small is-white" @click="setLatLon"
              >lat,lon</span
            >
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import L from "leaflet";

export default {
  name: "SetLocationMapModal",
  data() {
    return {
      map: undefined,
      marker: undefined,
    };
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
  },
  mounted() {
    this.initMap();

    EventBus.$on("SET_LOCATION_MAP", (coords) => {
      this.$nextTick(() => {
        this.redrawMap();
        this.updateMarkerLocation(coords);
      });
    });
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    setLatLon() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt'></i>&nbsp;Enter address coordinates
        </p>
        <p style='margin-bottom:12px'>
        You can manually enter the address coordinates if you know them.
        </p>
         <p style='margin-bottom:12px'>
        Enter as <button>lat,lon</button>
        </p>
        <p style='margin-bottom: 8px'>
        For example a google maps link contains the coordinates: 
        </p>
        <p style='font-size:0.8em; opacity:0.6'>
        https://www.google.com.sg/maps/search/199%2F72+Moo+Baan+Nai+Fun+2,+Soi+5a,+Canal+Road,+Mae+Hia/@18.739951,98.9316323,14.54z
        </p>
        </div>`,
        input: "text",
        inputPlaceholder: "18.739951,98.9316323",
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        showCloseButton: true,
        // cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 6 || txt.indexOf(",") === -1)
            return "Enter latitude,longitude";
        },
      }).then((val) => {
        if (val.value) {
          var nospace = val.value.replace(/ /g, "");
          var latString = nospace.split(",")[0];
          var lonString = nospace.split(",")[1];
          var lat = parseFloat(latString);
          var lon = parseFloat(lonString);
          var msg = `Incorrect format [ ${val.value} ] please enter latitude,longitude with no spaces.`;
          if (!lat || !lon) return this.errorToast(msg);
          this.infoToast(lat + ", " + lon);
          this.updateMarkerLocation([lat, lon]);
        }
      });
    },

    selectCountry(e) {
      console.log("selectCountry", e.target.value);
      var obj = { id: this.business.id, country: e.target.value };
      var loader = this.loadingDots("pink");
      this.$store
        .dispatch("updateBusiness", obj)
        .then((res) => {
          this.console("updateBusiness success", res);
          this.success();
          this.business.country = e.target.value;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    editAddress() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em;'><i class='fa fa-map-marker-alt'></i>&nbsp;Edit Address</p>
        <p style='margin-top:12px'>Give a short address for the shop.</p>
        <p style='margin-top:10px'>It shouldn't be the complete official address. Just a street number, street name 
        and possibly part of town will do:
        <p style='margin-top:10px'>e.g.&nbsp;<i>100 Nimman Soi 3</i></p>
        </p>
        </div>`,
        input: "textarea",
        inputValue: this.business.address,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val || val.length < 6) return "Enter an address";
        },
      }).then((val) => {
        if (val.value) {
          console.log("new address", val.value);
          var obj = { id: this.business.id, address: val.value };
          var loader = this.loadingDots("lightgreen");
          this.$store
            .dispatch("updateBusiness", obj)
            .then((res) => {
              this.console("updateBusiness success", res);
              this.success();
              this.business.address = val.value;
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    updateMarkerLocation(coords) {
      if (!this.marker || !coords) return;
      this.map.panTo(coords); //this.googleCoords); // setView, flyTo
      this.marker.setLatLng(coords); //this.map.getCenter());
    },
    redrawMap() {
      this.map.invalidateSize();
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles");

      var bangkokCoords = [13.73114, 100.57529]; // soi 41
      var initialLocation = this.$store.state.googleCoords;
      if (!initialLocation) initialLocation = bangkokCoords;

      this.map = L.map("business-location-map", {
        attributionControl: false,
      }).setView(
        initialLocation,
        17 // set zoom level
      );
      //   this.map.removeControl(this.map.zoomControl);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        maxZoom: 19,
      }).addTo(this.map);
      this.map.invalidateSize();

      this.marker = L.circleMarker(initialLocation, {
        color: "blue",
        fillColor: "gold",
        fillOpacity: 100,
        radius: 7,
      }).addTo(this.map);

      this.map.on("move", () => {
        this.marker.setLatLng(this.map.getCenter());
      });
      this.map.on("dragend", (e) => {
        this.console("marker moved", this.marker, e);
        this.marker.setLatLng(this.map.getCenter()); // needed?
      });
      this.marker.on("click", () => {
        this.$emit("setLocation", this.marker.getLatLng());
        this.closeModal();
      });
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  position: relative;
  height: 60vh;
  /* width: 90vw; */
}

#business-location-map {
  /* height: 60vh; */
  /* width: 86vw; */
  /* max-height: none; */
  height: 100%;
  position: relative;
  border-radius: 5px;
  /* position: inherit;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0; */
  /* width: 100%; */
}
.modal-card-body {
  padding: 12px;
  border-radius: 5px;
}
.notification {
  margin: 8px 0;
  padding: 10px;
  border-radius: 5px;
  font-weight: 500;
}
.lat-lon {
  position: absolute;
  z-index: 999;
  margin-top: -80px;
  margin-left: 10px;
}
.lat-lon .button {
  box-shadow: 1px 1px 4px grey;
}
</style>